<template>
  <div>
    <section
      class="
        mobile_add_new_head
        bg--blue
        tx--bege
        center
        flex flex--content--center
        relative
      "
    >
      <div class="title">עדכון מועד</div>
      <a
        class="m_bt_head head_go_back flex m-flex--center is-svg-w"
        @click.prevent="goBack"
      >
        <ArrowBackSvgMobile />
      </a>
      <a class="m_bt_head head_save" @click.prevent="saveAppSetTime">
        שמירה
      </a>
    </section>
    <section class="add_new_inner wrap-time-ups">
      <h2 class="subtitle center">
        באפשרותך לבחור מועד באופן ידני או מתוך רשימת תורים פנויים:
      </h2>
      <app-select-time
        :isValid="checkIsValid"
        :appointment="appointmentToEdit"
      />
    </section>
  </div>
</template>

<script>
import ShortenHours from "@/components/Popups/ShortenHours";
import HoursPop from "@/components/Popups/Hours";
import mixins from "../mixins/mixins.js";
import { mapGetters, mapState, mapMutations } from "vuex";
import Error from "@/components/Popups/Error";
import ArrowBackSvgMobile from "../assets/img/svg/arrow_back.svg";
import AppSelectTime from "@/components/Dashboard/Appoitments/AppSelectTime.vue";

export default {
  name: "TimeUpdate",
  mixins: [mixins],
  props: {
    isValid: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: "3",
        spaceBetween: 0,
        centeredSlides: false
      },
      appointmentToEdit: {},
      blocks: [],
      appointment_id: "",
      block_id: "",
      time_stamp: "",
      activeDates: {},
      selectedDate: "",
      selected_block: {},
      selectedTime: "",
      selectedDuration: "",
      invalidTime: false,
      appointment: {},
      filteredBlocks: [],
      need_to_short: true,
      checkIsValid: false
    };
  },
  mounted() {
    let times_arr = {};
    this.checkIsValid = this.isValid;
    this.$API.getAppointmentInfo(this.$route.params.id).then(res => {
      this.appointment = res.message.appointment;
      if (this.appointment) {
        let appointment = {
          birth_date: this.$moment(this.appointment.birthDate).format(
            "DD/MM/YYYY"
          ),
          selectedDate: this.appointment.start_datetime,
          block_id: this.appointment.surgery_block_id,
          phone: this.appointment.phone,
          phone2: this.appointment.second_phone,
          lang: this.appointment.language,
          date: this.$moment(this.appointment.start_datetime).format(
            "DD/MM/YYYY"
          ),
          duration: "",
          time: this.$moment(this.appointment.start_datetime).format("HH:mm"),
          files: [],
          notes: this.appointment.notes,
          notes2: "",
          first_name: this.appointment.firstName,
          last_name: this.appointment.lastName
        };

        let a = this.$moment(this.appointment.start_datetime);
        let b = this.$moment(this.appointment.end_datetime);
        let calcduration = b.diff(a, "minutes");
        if (calcduration > 0) {
          appointment.duration = calcduration;
        }

        this.appointmentToEdit = appointment;
      }

      this.doctor = res.message.doctor;
      this.documents = res.message.documents;
    });
  },
  methods: {
    ...mapMutations(["SET_APP_TIME_EDIT"]),
    getTodayEvents(date) {
      return new Promise((resolve, reject) => {
        let date_obj = this.$moment(date, "DD/MM/YYYY");
        let startdate = date_obj.format("YYYY-MM-DDTHH:mm");
        let endtdate = date_obj.add(1, "d").format("YYYY-MM-DDTHH:mm");
        let appointments = [];

        let wanted_date_start = this.$moment(
          this.selectedDate + " " + this.selectedTime.time,
          "DD/MM/YYYY HH:mm"
        );
        let wanted_date_end = wanted_date_start.add(this.selectedDuration, "m");
        this.$API
          .getFullCalendarEvents(
            this.activeUser.user_id,
            this.activeDoctor.id,
            "appointment",
            startdate,
            endtdate
          )
          .then(res => {
            appointments = res.filter(
              item =>
                item.parent_block_id == this.selectedTime.id &&
                item.appointment_id != this.appointment.id
            );

            if (appointments.length > 0) {
              for (const index in appointments) {
                const appointment = appointments[index];
                let appointement_start = this.$moment(
                  appointment.start,
                  "YYYY-MM-DD HH:mm:ss"
                );
                if (
                  wanted_date_end.isAfter(appointement_start) &&
                  appointment.parent_block_id == this.selectedTime.id
                ) {
                  this.$modal.show(ShortenHours, {
                    appointment: appointment,
                    hour_to_short: wanted_date_end
                  });
                  this.need_to_short = false;
                } else {
                  this.need_to_short = false;
                  this.saveApp();
                }
              }
            } else {
              this.need_to_short = false;
              this.saveApp();
            }
          })
          .catch(e => {
            this.$modal.show(Error);
          });
      });
    },
    async saveApp() {
      if (!this.appTimeEdit || !this.appTimeEdit.isValid) return;
      // return new Promise((resolve, reject) => {
      //   this.$refs.newAppointmentForm.validate().then(res => {
      // if (res) {
      // let date = this.$moment(
      //   this.appTimeEdit.date + " " + this.appTimeEdit.time,
      //   "DD/MM/YYYY LT"
      // );
      // if (this.need_to_short) {
      //   this.getTodayEvents(this.selectedDate).then(res => {});
      // }
      // if (!this.need_to_short) {
      let appDate = this.$moment(this.appTimeEdit.date, "DD/MM/YYYY").format(
        "YYYY-MM-DDT"
      );
      let appStart = appDate + this.appTimeEdit.time + ":00";
      let appEnd =
        appDate +
        this.$moment(this.appTimeEdit.time, "HH:mm")
          .add(this.appTimeEdit.duration, "m")
          .format("HH:mm:00");
      let app = {
        id: parseInt(this.$route.params.id),
        start: appStart,
        end: appEnd,
        over_block_id: this.appTimeEdit.block_id,
        title: "appointment"
      };
      const res = await this.$API.setAppointementsDatetime([app]);
      if (res.status === "OK") {
        this.goBack();
      } else {
        this.$modal.show(Error);
      }
      // this.$API
      //   .reScheduleAppointment(
      //     parseInt(this.$route.params.id),
      //     this.appTimeEdit.block_id,
      //     datetime
      //   )
      //   .then(res => {
      //     // resolve();
      //     // this.SET_APP_TIME_EDIT(null);
      //     this.goBack();
      //   })
      //   .catch(err => {
      //     this.$modal.show(Error);
      //   });
      // }
      // }
      //   });
      // });
    },
    selectTime($event, time, date) {
      let allBlocks = this.blocks;
      let selectedBlock = allBlocks.find(block => block.block_date == date);
      let parseddate = this.$moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");
      let parsedtime = this.$moment(parseddate + "T" + time.time);
      this.selected_block = selectedBlock;
      let start_datetime = this.$moment(this.appointment.start_datetime);
      let end_datetime = this.$moment(this.appointment.end_datetime);
      let duration = end_datetime.diff(start_datetime, "m");
      this.selectedDuration = duration;
      this.selectedTime = time;
      this.selectedDate = date;
      let time_elm = document.getElementsByClassName("book_hure");
      for (let i in time_elm) {
        if (time_elm[i].classList && time_elm[i].classList.contains("active")) {
          time_elm[i].classList.remove("active");
        }
      }
      $event.target.classList.add("active");
    },
    openPopHours() {
      this.$modal.show(HoursPop);
    },
    parseDate(date) {},
    getTimes(date) {
      let active_times = this.activeTimes;

      let parsedDate = this.$moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");

      let timesObject = {};

      for (let key in active_times) {
        if (key == parsedDate) {
          if (
            typeof timesObject[key] == "undefined" &&
            timesObject[key] !== active_times[key]
          ) {
            timesObject[key] = Object.values(active_times[key]);
          }
        }
      }
      return Object.values(timesObject)[0];
    },
    appointmentAbort() {
      this.$API
        .appointmentAbortLock(this.appointment_id)
        .then(res => {})
        .catch(e => {
          this.$modal.show(Error);
        });
    },
    saveAppSetTime() {
      this.checkIsValid = true;
      setTimeout(() => {
        this.saveApp();
      }, 300);
    }
  },
  watch: {
    isValid(val) {
      this.checkIsValid = val;
    }
  },
  computed: {
    ...mapGetters([
      "currentStep",
      "patient",
      "activeDoctor",
      "activeUser",
      "appTimeEdit"
    ]),
    ...mapState(["Appoitments"]),
    availableTimes() {
      var times_arr = [];
      if (this.Appoitments) {
        let blocks = this.Appoitments.selectedBlock;

        if (blocks) {
          blocks.map(block => {
            let availableTimes = block.available_time_slots_array;
            for (const index in availableTimes) {
              const slot = this.$moment(
                availableTimes[index][0],
                "YYYY-MM-DD HH:mm:ss"
              );
              const parsedDate = slot.format("DD/MM/YYYY");
              const parseTime = slot.format("HH:mm");
              if (!times_arr.hasOwnProperty(parsedDate)) {
                times_arr[parsedDate] = [];
              }
              let object = {
                id: availableTimes[index][4],
                time: parseTime
              };
              times_arr[parsedDate].push(object);
            }
          });
        }

        return times_arr;
      }
      return false;
    }
  },
  components: {
    ArrowBackSvgMobile,
    AppSelectTime
  }
};
</script>

<style scoped>
.book_hours_slide {
  padding-left: 0px;
}
.swiper-container {
  width: 100%;
}
.error.note-error {
  color: #b00020;
  border-top: 2px solid;
}
</style>
